export default {
  underlay_background_color: 'fafafa',
  underlay_text_color: '000000',
  tab_background_color: 'eeeeee',
  tab_background_hover_color: 'e4e4e4',
  tab_text_color: '000000',
  accent_color: 'AAAAAA',
  contrasting_accent_color: 'FFFFFF',
  visible_sections: {
    schedule: true,
    memberships: true,
    courses: true,
    requirements: true,
  },
  font: 'Default',
}
